import React from 'react';
import { styled } from 'baseui';

interface Props {
  name: string;
  href: string;
  className?: any;
  onClick?: () => void;
}

const StyledLink = styled('a', {
  ':focus': {
    textDecoration: 'underline'
  }
});

const ExternalLink: React.FC<Props> = ({ name, href, className, onClick }) => {
  return (
    <StyledLink
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      onClick={onClick}
      onKeyDown={(e: React.KeyboardEvent<HTMLAnchorElement>) => {
        console.log('Key pressed:', e.key);
        if (e.key === 'Enter' || e.key === ' ') {
          onClick && onClick();
        }
      }}
    >
      {name}
    </StyledLink>
  );
};

export default ExternalLink;
